module.exports = __webpack_public_path__ + "static/media/news-wine-pasta-donuts.9e2e700c.jpg";